<template>
  <page>
    <template #content>
      <v-breadcrumbs
        :items="bcItems"
        divider=">"
        class="mt-1"
        large
        />
      <v-row style="margin-left:15px; max-width:450px">
        <v-col cols="12" class="mb-n5">
          <v-text-field
            outlined
            dense
            v-model="newFirstname"
            label="first name"
            placeholder=" "
          />
        </v-col>
        <v-col cols="12" class="mb-n5">
          <v-text-field
            outlined
            dense
            v-model="newLastname"
            label="last name"
            placeholder=" "
          />
        </v-col>
        <v-col cols="12" class="mb-n5">
          <v-btn 
          :disabled="!validName" 
          :loading="updating" 
          color="primary" 
          @click="updateUserName"
            >Confirm</v-btn
          >
          <v-btn text @click="cancelButtonOnClick">Cancel</v-btn>
        </v-col>
      </v-row>
    </template>
  </page>
</template>

<script>
export default {
  data() {
    return {
      newFirstname: "",
      newLastname: "",
      updating: false
    }
  },
  computed: {
    validName() {
      if (this.newFirstname && this.newLastname) {
        return true
      }
      return false
    },
    bcItems: function (){
      return [
        {},
        {
          text: "Profile",
          disabled: false,
          exact: true,
          to: {name: 'Profile'},
        },
        {
          text: `${this.$route.meta.bcText}`,
          disabled: false,
          exact: true,
          href: `${this.$route.path}`
        },
      ]},
  },
  methods: {
    updateUserName() {
      this.updating = true
      this.$api.updateUserName(
        { firstname: this.newFirstname, lastname: this.newLastname },
        this.username,
        this.callBack(
          () => {
            this.alert("info", "Username updated successfully")
            this.$store.state.user.firstname = this.newFirstname
            this.$store.state.user.lastname = this.newLastname 
            this.$router.push({ name: "Home" })
          },
          (error) => {
            this.alert("error", error.message)
          },
          () => {
            this.updating = false
          }
        )
      )
    },
    cancelButtonOnClick() {
      this.$router.push({ name: "Home" })
    },
  },
}
</script>
